// Картинки ячеек: скачать или прочитать файл → уменьшить → JPEG data-URL.
// Так сетка самодостаточна: сохраняется в localStorage и рисуется на холсте без CORS-сюрпризов.

const MAX_SIDE = 560;
const MIN_SIDE = 40;
const FETCH_TIMEOUT_MS = 12000;
const MAX_FILE_BYTES = 25 * 1024 * 1024;

async function toDataUrl(bitmap) {
  const k = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const w = Math.max(1, Math.round(bitmap.width * k));
  const h = Math.max(1, Math.round(bitmap.height * k));
  if (bitmap.width < MIN_SIDE || bitmap.height < MIN_SIDE) throw new Error('Картинка слишком маленькая.');
  const c = document.createElement('canvas');
  c.width = w;
  c.height = h;
  const ctx = c.getContext('2d');
  ctx.fillStyle = '#ffffff';   // JPEG без прозрачности
  ctx.fillRect(0, 0, w, h);
  ctx.drawImage(bitmap, 0, 0, w, h);
  if (typeof bitmap.close === 'function') bitmap.close();
  return c.toDataURL('image/jpeg', 0.86);
}

export async function fromUrl(url) {
  const ctl = new AbortController();
  const t = setTimeout(() => ctl.abort(), FETCH_TIMEOUT_MS);
  try {
    const r = await fetch(url, { signal: ctl.signal, mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer' });
    if (!r.ok) throw new Error('нет картинки');
    const blob = await r.blob();
    if (!/^image\//.test(blob.type)) throw new Error('не картинка');
    return await toDataUrl(await createImageBitmap(blob, { imageOrientation: 'from-image' }));
  } finally {
    clearTimeout(t);
  }
}

export async function fromFile(file) {
  if (!file || !/^image\//.test(file.type)) throw new Error('Нужен файл-картинка (JPEG, PNG, WebP).');
  if (file.size > MAX_FILE_BYTES) throw new Error('Файл больше 25 МБ.');
  let bmp;
  try { bmp = await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch { throw new Error('Не удалось прочитать картинку.'); }
  return toDataUrl(bmp);
}

// Кэш готовых элементов <img> по data-URL (для рисования на холсте).
const cache = new Map();

export function imageFor(dataUrl) {
  if (!dataUrl) return null;
  let e = cache.get(dataUrl);
  if (!e) {
    const img = new Image();
    e = { img, ready: false, promise: null };
    e.promise = new Promise((resolve) => {
      img.onload = () => { e.ready = true; resolve(true); };
      img.onerror = () => resolve(false);
    });
    img.src = dataUrl;
    cache.set(dataUrl, e);
    if (cache.size > 40) cache.delete(cache.keys().next().value);
  }
  return e;
}

export async function preload(urls) {
  await Promise.all(urls.filter(Boolean).map((u) => imageFor(u).promise));
}
